import * as yup from "yup";

const schema = yup.object().shape({
  description: yup.string().required("Para salvar, insira uma descrição."),
});

export default schema;
